{
  "version": 1,
  "asset_id": "2af3db0c-e89e-44c7-bb4f-cdcb12cd5109",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2af3db0c-e89e-44c7-bb4f-cdcb12cd5109/gastric-bypass-es-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2af3db0c-e89e-44c7-bb4f-cdcb12cd5109/gastric-bypass-es-v2-1200.webp",
  "original_filename": "gastric-bypass-es-v2-1200.webp",
  "size": 75570,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:00:36Z"
}
